module.exports = __webpack_public_path__ + "static/media/foto1.d1aca654.png";